import { render, staticRenderFns } from "./LevelsPopup.vue?vue&type=template&id=572caa4e"
import script from "./LevelsPopup.vue?vue&type=script&lang=js"
export * from "./LevelsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports